import { Link } from 'react-router-dom';

function Footer() {
  return (
    <>
      <style>{`
        /* ============================================
           FOOTER 3iSENTER – fond bleu solide
           ============================================ */
        .ve-footer {
          background: #0a1628;
          color: #ffffff;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          padding-top: 70px;
          position: relative;
          overflow: hidden;
        }

        .ve-footer::before {
          content: '';
          position: absolute;
          top: -20%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(42, 95, 168, 0.08), transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 2;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          gap: 30px 20px;
        }

        .col-12 {
          flex: 0 0 100%;
          max-width: 100%;
        }

        @media (min-width: 576px) {
          .col-sm-6 {
            flex: 0 0 calc(50% - 10px);
            max-width: calc(50% - 10px);
          }
        }

        @media (min-width: 992px) {
          .col-lg-4 {
            flex: 0 0 calc(33.333% - 14px);
            max-width: calc(33.333% - 14px);
          }
          .col-lg-2 {
            flex: 0 0 calc(16.666% - 17px);
            max-width: calc(16.666% - 17px);
          }
          .col-lg-3 {
            flex: 0 0 calc(25% - 15px);
            max-width: calc(25% - 15px);
          }
        }

        .mb-50 {
          margin-bottom: 40px;
        }

        /* ===== BRAND / ABOUT ===== */
        .ve-footer-brand {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .ve-footer-logo {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          color: #ffffff;
          font-weight: 700;
          font-size: 1.5rem;
          letter-spacing: -0.5px;
          margin-bottom: 4px;
        }

        .ve-logo-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #2b7fd4, #4a90e2);
          border-radius: 12px;
          font-size: 1.3rem;
          font-weight: 800;
          color: #fff;
          box-shadow: 0 0 20px rgba(42, 95, 168, 0.35);
          transition: transform 0.4s ease;
        }

        .ve-footer-logo:hover .ve-logo-icon {
          transform: scale(1.10) rotate(-4deg);
        }

        .ve-logo-text {
          font-size: 1.35rem;
          font-weight: 600;
          color: #ffffff;
        }

        .ve-logo-text strong {
          color: #4a90e2;
          font-weight: 700;
        }

        .ve-footer-brand > p {
          font-size: 0.95rem;
          line-height: 1.6;
          color: rgba(255,255,255,0.7);
          max-width: 300px;
          margin: 0;
        }

        /* ===== TITRES & LISTES ===== */
        .ve-footer-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 18px;
          letter-spacing: 0.3px;
          position: relative;
          display: inline-block;
        }

        .ve-footer-title::after {
          content: '';
          position: absolute;
          bottom: -6px;
          left: 0;
          width: 30px;
          height: 3px;
          background: linear-gradient(90deg, #4a90e2, #2b7fd4);
          border-radius: 4px;
          transition: width 0.4s ease;
        }

        .ve-footer-title:hover::after {
          width: 50px;
        }

        .ve-footer-links,
        .ve-footer-contact {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .ve-footer-links li a,
        .ve-footer-contact li {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }

        .ve-footer-links li a:hover {
          color: #ffffff;
          transform: translateX(6px);
        }

        .ve-footer-links li a::before {
          content: '›';
          color: #4a90e2;
          font-size: 1.2rem;
          font-weight: 700;
          transition: transform 0.3s ease;
        }

        .ve-footer-links li a:hover::before {
          transform: translateX(4px);
        }

        .ve-footer-contact li {
          color: rgba(255,255,255,0.7);
          line-height: 1.5;
          gap: 12px;
        }

        .ve-footer-contact li i {
          color: #4a90e2;
          font-size: 1.1rem;
          width: 20px;
          text-align: center;
          flex-shrink: 0;
        }

        /* ===== FOOTER BOTTOM ===== */
        .ve-footer-bottom {
          margin-top: 20px;
          padding: 20px 0;
          border-top: 1px solid rgba(255,255,255,0.06);
          background: rgba(0,0,0,0.2);
        }

        .ve-footer-bottom-inner {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }

        .ve-footer-bottom-inner p {
          font-size: 0.9rem;
          color: rgba(255,255,255,0.6);
          margin: 0;
        }

        .ve-footer-bottom-inner p a {
          color: rgba(255,255,255,0.8);
          text-decoration: none;
          transition: color 0.3s;
        }

        .ve-footer-bottom-inner p a:hover {
          color: #4a90e2;
        }

        .ve-footer-bottom-inner ul {
          list-style: none;
          display: flex;
          gap: 20px;
          padding: 0;
          margin: 0;
        }

        .ve-footer-bottom-inner ul li a {
          color: rgba(255,255,255,0.6);
          text-decoration: none;
          font-size: 0.85rem;
          transition: color 0.3s;
        }

        .ve-footer-bottom-inner ul li a:hover {
          color: #ffffff;
        }

        /* ===== ANIMATIONS ===== */
        .ve-footer .row > div {
          opacity: 0;
          transform: translateY(30px);
          animation: footerFadeUp 0.8s ease forwards;
        }

        .ve-footer .row > div:nth-child(1) { animation-delay: 0.05s; }
        .ve-footer .row > div:nth-child(2) { animation-delay: 0.10s; }
        .ve-footer .row > div:nth-child(3) { animation-delay: 0.15s; }
        .ve-footer .row > div:nth-child(4) { animation-delay: 0.20s; }

        @keyframes footerFadeUp {
          to { opacity: 1; transform: translateY(0); }
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 991px) {
          .ve-footer {
            padding-top: 50px;
          }
          .col-sm-6 {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .ve-footer-brand > p {
            max-width: 100%;
          }
        }

        @media (max-width: 576px) {
          .ve-footer-bottom-inner {
            flex-direction: column;
            text-align: center;
          }
          .ve-footer-bottom-inner ul {
            flex-wrap: wrap;
            justify-content: center;
          }
          .ve-footer-brand {
            align-items: center;
            text-align: center;
          }
          .ve-footer-title::after {
            left: 50%;
            transform: translateX(-50%);
          }
          .ve-footer-title:hover::after {
            width: 50px;
          }
          .ve-footer-links li a {
            justify-content: center;
          }
          .ve-footer-contact li {
            justify-content: center;
          }
        }

        /* ===== FALLBACK FONT AWESOME ===== */
        .fa, .fas, .far, .fal, .fab {
          font-family: 'Font Awesome 6 Free' !important;
          font-weight: 900;
        }
        .fa-map-marker::before { content: "📍"; font-style: normal; }
        .fa-phone::before { content: "📞"; font-style: normal; }
        .fa-envelope::before { content: "✉️"; font-style: normal; }
      `}</style>

      <footer className="ve-footer">
        <div className="container">
          <div className="row">
            {/* Col 1: Brand / About */}
            <div className="col-12 col-sm-6 col-lg-4 mb-50">
              <div className="ve-footer-brand">
                <Link to="/" className="ve-footer-logo">
                  <span className="ve-logo-icon">3</span>
                  <span className="ve-logo-text">3i<strong>SENTER</strong></span>
                </Link>
                <p>
                  3iSENTER est un cabinet spécialisé en formation professionnelle,
                  gestion des ressources humaines et placement de talents.
                  Nous accompagnons les entreprises et les individus vers l’excellence.
                </p>
              </div>
            </div>

            {/* Col 2: Quick Links */}
            <div className="col-12 col-sm-6 col-lg-2 mb-50">
              <h5 className="ve-footer-title">Liens rapides</h5>
              <ul className="ve-footer-links">
                <li><Link to="/">Accueil</Link></li>
                <li><Link to="/about">À propos</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Col 3: Services */}
            <div className="col-12 col-sm-6 col-lg-3 mb-50">
              <h5 className="ve-footer-title">Nos services</h5>
              <ul className="ve-footer-links">
                <li><Link to="/nos-formations">Formation professionnelle</Link></li>
                <li><Link to="/nos-offres">Offres d'emplois</Link></li>
                <li><Link to="/login">ERP BISENTER</Link></li>
              </ul>
            </div>

            {/* Col 4: Contact */}
            <div className="col-12 col-sm-6 col-lg-3 mb-50">
              <h5 className="ve-footer-title">Contact</h5>
              <ul className="ve-footer-contact">
                <li>
                  <i className="fa fa-map-marker"></i>
                  Nouvelle galerie présémiante Rcm 7-8,<br />
                  Rez de chaussée, Maasdam 7-8, RDC
                </li>
                <li><i className="fa fa-phone"></i> +243 85106166</li>
                <li><i className="fa fa-envelope"></i> contact@bisenter.com</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="ve-footer-bottom">
          <div className="container">
            <div className="ve-footer-bottom-inner">
              <p>
                © {new Date().getFullYear()} 3iSENTER SARLU. Tous droits réservés.
              </p>
              <ul>
                <li><a href="#">Mentions légales</a></li>
                <li><a href="#">Politique de confidentialité</a></li>
                <li><a href="#">CGU</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;